<script lang="ts">
  import Link from "$lib/components/Link.svelte";
</script>

<div class="min-h-screen flex items-center justify-center px-4">
  <div class="card max-w-md text-center">
    <h1 class="text-2xl font-bold mb-2">404</h1>
    <p class="text-slate-600 mb-4">Página não encontrada.</p>
    <Link to="/" class="btn-primary inline-block">Voltar ao início</Link>
  </div>
</div>
